export default function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
// module id = 1158
// module chunks = 0